<!-- 
  © 2025 Ananda Kumar. All rights reserved.
  Unauthorized copying of this file, via any medium, is strictly prohibited.
-->
<p>spl-grp-menu works!</p>
